
        <base-modal
                [title]="title"
                [isLoading]="isLoading"
                [isBtnOkActive]="isBtnOkActive"
                [form]="form"
        >
            <form [formGroup]="form">
                <div class="form-group">
                    <label for="name">ID оплаты</label>

                    <select
                            class="form-control"
                            formControlName="transactionId"
                            [formErrorIndicator]="transactionId"
                    >
                        <option *ngFor="let transaction of transactions" value="{{ transaction.transactionId }}">
                            {{  niceTransaction(transaction) }}
                        </option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="name">Типа возврата</label>

                    <select
                            class="form-control"
                            formControlName="type"
                            [formErrorIndicator]="type"
                    >
                        <option *ngFor="let type of types" value="{{ type }}">
                            {{ 'adminstat.support.return paid.' + type | translate }}
                        </option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="name">Сумма возврата</label>

                    <div class="input-group" [formErrorIndicator]="amount">
                        <input
                                type="text"
                                class="form-control"
                                formControlName="amount"
                                [readonly]="(type.value === 'warrantyPeriod' || type.value === 'secondPaid')"
                        />

                        <div class="input-group-append">
                            <span class="input-group-text" id="inputGroupPrepend">$</span>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label for="name">Оставить тарифа</label>

                    <select
                            class="form-control"
                            formControlName="stayTariff"
                            [formErrorIndicator]="stayTariff"
                    >
                        <option *ngFor="let stayTariff of stayTariffs" value="{{ stayTariff }}">
                            {{ 'adminstat.support.return paid.' + stayTariff | translate }}
                        </option>
                    </select>

                    <datepicker
                            formControlName="dateTo"
                            [disabledPast]="true"
                            [hidden]="stayTariff.value !== 'manual'"
                            [formErrorIndicator]="dateTo"
                    ></datepicker>
                </div>

                <div class="form-group">
                    <label for="name">Коментарий</label>
                    <textarea
							class="form-control"
							id="comment"
							formControlName="comment"
							[formErrorIndicator]="comment"
					></textarea>
                </div>
            </form>
        </base-modal>
	